export const SUPPORTED_SAGE_VERSIONS = ["2021.4", "2022.1", "2023", "2024"];
export const DEFAULT_SAGE_VERSION = "2024";
export function isSupportedSageVersion(value) {
    return (typeof value === "string" &&
        SUPPORTED_SAGE_VERSIONS.includes(value));
}
